<template>
	<div>
		<div v-if="error" class="alert alert-danger">{{error}}</div>
		<form class="form">
			<div class="form-group">
				<label for="service">Service</label>
				<input type="text" id="service" class="form-control" v-model="formPricing.service" placeholder="Service" />
			</div>
			<div class="form-group">
				<label for="target">Target</label>
				<input type="text" id="target" class="form-control" v-model="formPricing.target" placeholder="Target" />
			</div>
			<div class="form-group">
				<label for="metric">Metric</label>
				<input type="text" id="metric" class="form-control" v-model="formPricing.metric" placeholder="Metric" />
			</div>
			<div class="form-group">
				<label for="measure">Measure</label>
				<input type="text" id="measure" class="form-control" v-model="formPricing.measure" placeholder="Measure" />
			</div>
			<div class="form-group">
				<label for="cents">Cents</label>
				<input type="number" id="cents" class="form-control" v-model="formPricing.cents" placeholder="Cents" />
			</div>
			<div class="form-group">
				<label for="units">Units</label>
				<input type="number" id="units" class="form-control" v-model="formPricing.units" placeholder="Units" />
			</div>
		</form>
		<div class="form-group mt-5 text-right">
			<button class="btn btn-secondary mr-2" @click="cancel">Cancel</button>
			<button class="btn btn-primary" @click="save">
				<span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>Save
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "PricingEdit",
	props: ["pricing", "error", "loading"],
	data() {
		return {
			formPricing: Object.assign({}, this.pricing)
		}
	},
	methods: {
		save: function () {
			this.$emit("request-save", this.formPricing);
		},
		cancel: function () {
			this.$emit("close");
		},
	},
};
</script>

<style>
</style>